import React from 'react'
import classnames from 'classnames/bind'
// @ts-ignore no types
import { Text } from '@adc/ui-adc'
import { Duration } from 'common/modules/bidBanner/auctionDuration'
import * as blueprint from '@adc/blueprint'
import {
  CombinedListingType,
  ShortenedOnlineSegmentType,
  useListingContext,
} from 'common/context/listing'
import {
  Starting,
  getServerTimeMoment,
  getStartTimeMoment,
} from '../../auctionCountdown/index'
import hasSimilarProperties from '../../../utils/hasSimilarProperties'
import { shouldShowSealedBidTreatment } from '../../../utils/privateSeller'
import AuctionDetailsTemplate, {
  MessageContentContainer,
  RegistrationButton,
  tpsAdditionalContent,
} from '../template'
import { matchBidHeaderContent } from '../../../components/bidBanner/matchBid/matchBidHeader/index'
import {
  firstLookHeaderContent,
  firstLookEndContent,
} from '../firstLookAuctionDetails'
import styles from '../index.scss'
import CalendarPopup from './calendar'
import SealedBidStatusMessageBox from './sealedBidStatusMessageBox'
import { getERVRow } from './common'

const cx = classnames.bind(styles)

// CONNOR ADDS A TODO TO TODO: Make the component using our fancy new `Slot` pattern.

const detailContent = (
  isInTour: boolean,
  isFirstLookEnabled: boolean,
  isRedesignEnabled: boolean,
  segment: ShortenedOnlineSegmentType,
  listing: CombinedListingType
) => {
  const details = [
    {
      label: (
        <Text color='gray' data-elm-id='countdown_timer_label'>
          {listing.is_current_user_registered_for_online_auction
            ? 'Come Back to Bid In'
            : 'Auction Starts In'}
        </Text>
      ),
      value: (
        <Text color='gray' weight='heavy' data-elm-id='countdown_timer_value'>
          <Starting
            className={cx('starting')}
            endTime={getStartTimeMoment(segment)}
            currentServerTime={getServerTimeMoment(segment)}
          />
        </Text>
      ),
    },
    {
      label: (
        <Text color='gray' data-elm-id='auction_duration_label'>
          Duration
        </Text>
      ),
      value: (
        <Text color='gray' weight='heavy' data-elm-id='auction_duration_value'>
          <Duration
            startDateTime={String(segment.start_date)} // was b.startDateTime
            endDateTime={String(segment.initial_end_date)} // was b.endDateTime
          />
          <CalendarPopup isInTour={isInTour} />
        </Text>
      ),
    },
  ]
  if (isFirstLookEnabled) details.push(firstLookEndContent(listing))
  const ervRow = getERVRow(listing, isRedesignEnabled)
  ervRow && details.unshift(ervRow)

  return details
}

interface BeforeProps {
  isInTour: boolean
  similarProperties: any[]
  featureFlags: Record<string, any>
  isFirstLookEnabled: boolean
  isMatchBiddingEnabled: boolean
  user: blueprint.primitives.AuctionUser
  isRedesignEnabled: boolean
}

const Before = ({
  isInTour,
  similarProperties,
  featureFlags,
  isFirstLookEnabled,
  isMatchBiddingEnabled,
  user,
  isRedesignEnabled,
}: BeforeProps) => {
  const { segment, listing } = useListingContext()

  const shouldShowSealedBidTreatmentForListing = shouldShowSealedBidTreatment({
    segment,
    featureFlags,
  })
  const title = shouldShowSealedBidTreatmentForListing ? '' : 'Online Auction'

  let additionalContent
  if (blueprint.listing.utils.isFclOnlineAuction(listing)) {
    additionalContent = tpsAdditionalContent(
      hasSimilarProperties(similarProperties)
    )
  } else if (shouldShowSealedBidTreatmentForListing) {
    additionalContent = <SealedBidStatusMessageBox />
  }

  return (
    <>
      <AuctionDetailsTemplate
        title={title}
        primaryButton={<RegistrationButton featureFlags={featureFlags} />}
        additionalContent={additionalContent}
        detailContent={detailContent(
          isInTour,
          isFirstLookEnabled,
          isRedesignEnabled,
          segment,
          listing
        )}
        headerContent={
          isFirstLookEnabled
            ? firstLookHeaderContent()
            : isMatchBiddingEnabled && matchBidHeaderContent()
        }
        messageContent={
          <MessageContentContainer
            featureFlags={featureFlags}
            enableBidDepositRequiredMessage
            user={user}
            shouldShowSealedBidTreatment={
              shouldShowSealedBidTreatmentForListing
            }
          />
        }
      />
    </>
  )
}

export default Before
